import PropTypes from 'prop-types';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Box, BoxProps } from '@mui/material';

type ImageProps = BoxProps & {
  src?: string;
  alt?: string;
  sx?: object;
  visibleByDefault?: boolean;
  wrapperClassName?: string;
  [key: string]: any;
};

Image.propTypes = {
  sx: PropTypes.object,
  src: PropTypes.string,
  alt: PropTypes.string,
};

export default function Image({ sx, ...other }: ImageProps) {
  return (
    <Box
      component='span'
      sx={{
        lineHeight: 0,
        display: 'block',
        overflow: 'hidden',
        '& .wrapper': {
          width: 1,
          height: 1,
          backgroundSize: 'cover !important',
        },
        ...sx,
      }}
    >
      <Box
        component={LazyLoadImage}
        wrapperClassName='wrapper'
        sx={{ width: 1, height: 'auto', objectFit: 'contain' }}
        visibleByDefault
        alt='image'
        {...other}
      />
    </Box>
  );
}
